import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import React from "react";
import { KegiatanSosialResponse } from "../../../models/KegiatanSosial";
import {
  BaseGrid,
  StyledTableRow,
  TableCellHeader,
  TableCellWidth,
  TitleTypography,
} from "../KandidatViewPage";

type Props = { data: KegiatanSosialResponse[] };

export default function DataKegiatanSosialKandidatPage({ data }: Props) {
  return (
    <BaseGrid container item xs={12} justifyContent="center">
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
          marginBottom: "4%",
        }}
      >
        <TitleTypography>Data Kegiatan Sosial</TitleTypography>
      </Grid>
      <Grid container item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <TableCellHeader>Organisasi</TableCellHeader>
                <TableCellHeader>Kegiatan</TableCellHeader>
                <TableCellHeader>Jabatan</TableCellHeader>
                <TableCellHeader>Tahun</TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, key) => (
                <StyledTableRow key={key}>
                  <TableCellWidth>{row.ORGINASASI}</TableCellWidth>
                  <TableCellWidth>{row.KEGIATAN}</TableCellWidth>
                  <TableCellWidth>{row.JABATAN}</TableCellWidth>
                  <TableCellWidth>{row.TAHUN}</TableCellWidth>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </BaseGrid>
  );
}
